<div class="loading" *ngIf="loading; else doneLoading">
	<div class="loading__blur-container">
		<div class="loading__circle-container">
			<div class="loading__circle loading__circle--top"></div>
			<div class="loading__circle loading__circle--right"></div>
			<div class="loading__circle loading__circle--bottom"></div>
			<div class="loading__circle loading__circle--left"></div>
			<div class="loading__circle--center"></div>
		</div>
		<div class="loading__logo">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
				<path
					fill="#fff"
					d="M281.4,496.22C145.86,496.22,35.6,386,35.6,250.42S145.86,4.62,281.4,4.62a244.16,244.16,0,0,1,173.8,72l9.93,9.92-50.58,50.58-9.92-9.93a173.14,173.14,0,0,0-123.23-51c-96.1,0-174.28,78.18-174.28,174.27S185.3,424.7,281.4,424.7a173,173,0,0,0,112.92-41.51l-10.93-10.92a157.68,157.68,0,0,1-102,37c-87.61,0-158.89-71.28-158.89-158.89S193.79,91.53,281.4,91.53a157.85,157.85,0,0,1,112.35,46.54,14,14,0,1,1-19.85,19.85,130,130,0,0,0-92.5-38.32c-72.14,0-130.82,58.69-130.82,130.82A130.82,130.82,0,0,0,373.9,342.93l9.93-9.93,50.57,50.58-9.92,9.92A201,201,0,0,1,281.4,452.77C169.82,452.77,79.05,362,79.05,250.42S169.82,48.08,281.4,48.08A200.84,200.84,0,0,1,414.22,97.76l10.9-10.91A216.16,216.16,0,0,0,281.4,32.69c-120.06,0-217.73,97.68-217.73,217.73S161.34,468.15,281.4,468.15a216.35,216.35,0,0,0,154-63.77,14,14,0,0,1,19.84,19.85A244.2,244.2,0,0,1,281.4,496.22Z"
				/>
			</svg>
		</div>
	</div>
</div>

<ng-template #doneLoading>
	<div
		class="flex flex-col items-center py-10 px-16"
		*ngIf="error; else showRegisterComponent"
	>
		<img
			src="/assets/images/closer-logos/closer-logo-full.webp"
			alt="Closer"
			class="login-header__logo"
		/>
		<ng-container *ngIf="inviteId | isSet">
			<h4 class="mt-6 text-center">Your invitation could not be found.</h4>
			<p class="mt-6 text-center">
				Please contact an admin at your organization to troubleshoot.
			</p>
			<app-anchor type="bold" [url]="loginUrl" class="mt-4">Log in</app-anchor>
		</ng-container>
		<ng-container *ngIf="(signUpRequestId | isSet) || !(inviteId | isSet)">
			<h4 class="mt-6 text-center">Your sign up request could not be found.</h4>
			<p class="mt-6 text-center">
				Please contact us at
				<a
					emailLinkInterceptor
					href="mailto:support@lawlabs.ca"
					class="text-underline"
					>support&#64;lawlabs.ca</a
				>
			</p>
		</ng-container>
	</div>
</ng-template>

<ng-template #showRegisterComponent>
	<app-auth-container
		label="Sign up"
		description="Begin your journey with Closer, Ontario's leading all-in-one conveyancing solution."
		submitButtonText="Sign Up"
		[formGroup]="authForm"
		[disabled]="loading$ | async"
		[loading]="loading$ | async"
		(onFormSubmit)="registerUser()"
	>
		<ng-container form-content>
			<app-input
				label="Email"
				placeholder="Enter your work email"
				[required]="true"
				[formControlName]="USER_CREDENTIALS.EMAIL"
			></app-input>

			<app-input
				label="Password"
				[required]="true"
				[formControlName]="USER_CREDENTIALS.PASSWORD"
				placeholder="Create a strong password 💪"
				type="password"
				minLength="6"
				minLengthLabel="Password"
			></app-input>

			<app-input
				label="Confirm password"
				placeholder="Re-enter your password"
				[required]="true"
				[formControlName]="USER_CREDENTIALS.CONFIRM"
				type="password"
			></app-input>

			<ui-checkbox
				[formControlName]="USER_CREDENTIALS.SIGNUP_AGREEMENT"
				[required]="true"
				label="I accept Closer's Terms of Service."
			/>

			<div class="p-sm flex gap-1">
				<p>Read our</p>
				<app-anchor type="bold" [url]="legalUrl" [external]="true"
					>Terms of Service</app-anchor
				>
			</div>
		</ng-container>

		<ng-container footer-content>
			<p>Already have an account?</p>
			<app-anchor type="bold" [url]="loginUrl">Log in</app-anchor>
		</ng-container>
	</app-auth-container>
</ng-template>
